import React from "react";

const PrivacyPolicy = () => {
  return (
<div className="w-full bg-gray-500" style={{ padding: "40px" }}> 
<div className="mx-auto px-8 sm:px-12 md:px-16 lg:px-24" > 
        <h1 className="text-3xl font-bold">PRIVACY POLICY</h1>

        <p>
          This Privacy Policy ("Policy") explains how <strong>FinReliable Technology IMF Private Limited</strong>, doing business as <strong>FinReliable Technology IMF</strong> ("we", "us", or "our"), collects, uses, discloses, and protects the Personal Information of users ("you", "your") of our Insurance portal ("Website") available at <a href="https://www.finrelinsure.com" className="underline text-blue-600">https://www.finrelinsure.com</a>. This Policy is incorporated by reference into our Terms & Conditions and governs your use of our services. By accessing or using our Website, you agree to the collection and use of your information as described in this Policy.
        </p>

        <h2 className="text-2xl font-semibold mt-8">1. INFORMATION WE COLLECT</h2>

        <p className="font-semibold">1.1 Personal Information</p>
        <p>
          When you register for or use our insurance solutions (such as car insurance, bike insurance, health insurance, travel insurance, home insurance etc.), we may collect the following Personal Information:
        </p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Identity Information:</strong> Your full name, email address, mobile number, and other details you provide during registration.</li>
          <li><strong>Vehicle and Account Information:</strong> Information about your vehicle(s) such as registration numbers and details necessary for Insurance transactions.</li>
          <li><strong>Financial Information:</strong> Payment-related details required for processing transactions (note: we do not store complete credit/debit card numbers; only the last four digits may be retained for record purposes).</li>
          <li><strong>Verification Data:</strong> Identification documents or numbers (e.g., Aadhaar, PAN, Passport) if required to verify your identity or complete KYC processes.</li>
        </ul>

        <p className="font-semibold">1.2 Usage Data</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>IP address, browser type, device details, operating system, and other technical data.</li>
          <li>Pages visited, time spent on pages, and clickstream data.</li>
          <li>Transaction details including insurance payments and service interactions.</li>
        </ul>

        <p className="font-semibold">1.3 Cookies and Tracking Technologies</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Enhance and personalize your experience on our Website.</li>
          <li>Analyze usage patterns and monitor the performance of our Website.</li>
          <li>Track your preferences and interactions for service improvement.</li>
        </ul>
        <p>
          Most web browsers allow you to manage cookies through their settings. Disabling cookies may impact certain functionalities of our Website. We do not store Personally Identifiable Information in cookies.
        </p>

        <h2 className="text-2xl font-semibold mt-8">2. HOW WE USE YOUR INFORMATION</h2>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Service Provision:</strong> To create and manage your insurance transactions, and deliver insurance related services securely.</li>
          <li><strong>Personalization:</strong> To tailor your experience on our Website and provide you with relevant communications and service updates.</li>
          <li><strong>Communication:</strong> To send you notifications, customer support messages, and other important information regarding your account and transactions.</li>
          <li><strong>Security and Fraud Prevention:</strong> To protect our systems, detect and prevent fraudulent or unauthorized activities, and ensure compliance with legal and regulatory obligations.</li>
          <li><strong>Analytics and Improvement:</strong> To analyze usage trends, measure performance, and continuously improve our services and Website functionality.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8">3. SHARING AND DISCLOSURE OF INFORMATION</h2>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Service Providers:</strong> With trusted third-party vendors who assist us with payment processing, data analytics, customer support, and other operational services.</li>
          <li><strong>Affiliates and Partners:</strong> With other companies within our corporate group or with our strategic partners, but only on a need-to-know basis.</li>
          <li><strong>Legal Requirements:</strong> When required by law, regulation, or legal process, or to protect our rights or the safety of others.</li>
          <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of all or part of our business, your information may be transferred to the new owner.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8">4. DATA SECURITY</h2>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Encryption:</strong> Utilizing Secure Socket Layer (SSL) technology to encrypt data transmitted between your device and our servers.</li>
          <li><strong>Access Controls:</strong> Restricting access to your Personal Information to authorized personnel only.</li>
          <li><strong>Physical Security:</strong> Employing physical security measures at our data centers to protect stored data.</li>
        </ul>
        <p>
          While we strive to secure your data, no transmission or storage method is 100% secure. By using our Website, you acknowledge and accept this inherent risk.
        </p>

        <h2 className="text-2xl font-semibold mt-8">5. DATA RETENTION</h2>
        <p>
          We retain your Personal Information only for as long as necessary to fulfill the purposes for which it was collected, to comply with legal obligations, or to resolve disputes. Once the retention period expires, your data will be securely deleted or anonymized.
        </p>

        <h2 className="text-2xl font-semibold mt-8">6. YOUR RIGHTS</h2>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Access and Correction: The right to access and update your Personal Information.</li>
          <li>Consent Withdrawal: The right to withdraw your consent to our data processing practices.</li>
          <li>Data Portability: The right to request the transfer of your Personal Information to another organization.</li>
          <li>Objection and Restriction: The right to object to or restrict certain types of data processing.</li>
        </ul>
        <p>
          To exercise these rights, please contact us at <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>. Some rights may be subject to legal limitations.
        </p>

        <h2 className="text-2xl font-semibold mt-8">7. INTERNATIONAL DATA TRANSFERS</h2>
        <p>
          If you access our Website from outside India, your Personal Information may be transferred to and stored in India. By using our Website, you consent to such transfers in accordance with this Policy.
        </p>

        <h2 className="text-2xl font-semibold mt-8">8. CHANGES TO THIS PRIVACY POLICY</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. When significant changes occur, registered users will be notified via email and on our Website. Your continued use of our services after any changes constitutes your acceptance of the updated Policy.
        </p>

        <h2 className="text-2xl font-semibold mt-8">9. CONTACT US</h2>
        <p>
          If you have any questions, concerns, or requests regarding this privacy policy or our data practices, please contact us at: <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
